import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CommentsByCommentType, CommentsPayloadDTO, CommentsResponseDTO } from '@core/model';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { SelectItem } from 'primeng/api';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {
  private readonly apiUrl = inject(ShellService).getBaseUrlFor(ProductNames.CHAPP);
  private readonly http = inject(HttpClient);

  getComments(authorizationId: string): Observable<CommentsByCommentType[]> {
    return this.http.get<CommentsResponseDTO>(`${this.apiUrl}/chapp/authorizations/${authorizationId}/comments`)
      .pipe(map(data => data.commentsByCommentType));
  }

  getActiveReferralTypes(authorizationId: string): Observable<SelectItem<string>[]> {
    return this.http.get<SelectItem<string>[]>(`${this.apiUrl}/chapp/authorizations/${authorizationId}/activeReferraltypes`);
  }

  createComment(authorizationId: string, payload: CommentsPayloadDTO): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/chapp/authorizations/${authorizationId}/comments`, payload);
  }

  editComment(authorizationId: string, commentId: string, payload: CommentsPayloadDTO): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/chapp/authorizations/${authorizationId}/comments/${commentId}`, payload);
  }
  
  markCommentsAsRead(authorizationId: string, commentsIds: string[]): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/chapp/authorizations/${authorizationId}/comments/mark-as-read`, commentsIds);
  }

  pinUnpinComment(authorizationId: string, commentId: string, pinState: boolean): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}/chapp/authorizations/${authorizationId}/comments/pin-or-unpin/${commentId}`,
      { pinState }
    );
  }
}
